import React, { useState, useEffect ,useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import { db, auth } from '../firebase';
import { collection, addDoc, doc, getDoc,getDocs,updateDoc,deleteDoc,setDoc,query, where,orderBy, limit } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import BackHomeButton from '../components/BackHomeButton';
import RazorpayButton from '../components/RazorpayButton';
import { useLocation } from 'react-router-dom';
import Get_Help from '../components/Get_Help';
import Help_Video from '../components/Help_Video';
import { getStorage, ref, listAll, getDownloadURL } from "firebase/storage";

import { functions } from '../firebase'; // Ensure path is correct
import { httpsCallable } from 'firebase/functions';



const AIQuestionTest_CBSE_NCERT = () => {
  const [user, setUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [welcomePage, setWelcomePage] = useState(true);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [userAnswers, setUserAnswers] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const [isFinished, setIsFinished] = useState(false);
  const [score, setScore] = useState(0);
  const [aiTopicOptions, setAiTopicOptions] = useState([]);



  const [maxQuestions ,setmaxQuestions] = useState(20);

  const [subject, setSubject] = useState('');
  const [standard, setStandard] = useState("");
  const [topic, setTopic] = useState('');
  const [format, setFormat] = useState('');
  const [sampleQuestions, setSampleQuestions] = useState('');
  const [previousQuestions, setPreviousQuestions] = useState([]);
  const [school, setSchool] = useState("");

  const [savedLessons, setSavedLessons] = useState([]);
  const [selectedLessonId, setSelectedLessonId] = useState('');
  const [selectedLessonText, setSelectedLessonText] = useState('');
  const [selectedLessonName, setSelectedLessonName] = useState('');


  const [allQuestions, setAllQuestions] = useState([]);


  const navigate = useNavigate();

const location = useLocation();

  const [ Premiumenddate,setPremiumenddate ] = useState('');
  const [UserType,setUserType]=useState('');
  const [generationsLeft, setGenerationsLeft] = useState('');
  const [hoveredButton, setHoveredButton] = useState(null);
   const [loading, setLoading] = useState(false);

   const [qloading, setqLoading] = useState(false);

   const [aiSummary, setAiSummary] = useState("");
   
   const [isAiSummaryLoading, setIsAiSummaryLoading] = useState(false);

   const [resultsString, setResultsString] = useState("");


const storage = getStorage();

  const [subjectList, setSubjectList] = useState([]);

  const [timeLeft, setTimeLeft] = useState(30);            // seconds remaining for current question
  const [autoSubmitted, setAutoSubmitted] = useState(false);
  const countdownTimeoutRef = useRef(null);

  const [showRewardBox, setShowRewardBox] = useState(false);
  const [rewardImages, setRewardImages] = useState([]);
  const [rewardRevealed, setRewardRevealed] = useState(false);
  const [Pass_Percentage,Set_Pass_Percentage] = useState(0); 
  const [preference,setPreference] = useState('No');

  const [showReviewModal, setShowReviewModal] = useState(false);
  const [reviewContent, setReviewContent] = useState("");
  const [pendingQuestions, setPendingQuestions] = useState([]);
  const [rejectedHistory, setRejectedHistory] = useState([]);
 


  let combinedText = "";

    const handleNavigation = (path, state = {}) => {
    navigate(path, { state });
  };

const getDurationForSubject = (subjectName) => {
  // seconds by subject (customize as you like)
  const map = {
    'Maths': 60,             // 1 minute
    'English Language': 30, // 2 minutes
    'Hindi Language': 30,    // 1.5 minutes
    'GK': 30,
    'Computer': 30
  };
  return map[questionIndex,subjectName] || 30; // default 60s
};

const fetchAllRewards = async () => {
  try {
    const rewardsRef = ref(storage, "Rewards");
    const result = await listAll(rewardsRef);

    const urls = await Promise.all(
      result.items.map(item => getDownloadURL(item))
    );

    setRewardImages(urls);
  } catch (err) {
    console.error("Failed to fetch rewards:", err);
  }
};

useEffect(() => {
  const HARD_CODED_SUBJECTS = [
    "Maths",
    "English Language",
    "Hindi Language",
    "English Literature",
    "Hindi Literature",
  ];

  // Reset topic & AI topics on ANY subject change
  setAiTopicOptions([]);
  setTopic("");

  // If subject is hardcoded → stop here
  if (HARD_CODED_SUBJECTS.includes(subject)) {
    return;
  }

  // If no lesson selected → fallback will be "Full Text"
  if (!selectedLessonId) {
    return;
  }

  const fetchTopics = async () => {
    try {
      // ⚠️ IMPORTANT: only ONE lesson at a time
      const lessonId = selectedLessonId;

      const ref = doc(db, "saved_lessons_topics", lessonId);
      const snap = await getDoc(ref);

      if (!snap.exists()) {
        setAiTopicOptions([]);
        return;
      }

      const rawTopics = snap.data().topics;

      let parsedTopics = [];

      if (typeof rawTopics === "string") {
        parsedTopics = rawTopics
          .split("*")
          .map(t => t.trim())
          .filter(Boolean);
      } else if (Array.isArray(rawTopics)) {
        parsedTopics = rawTopics;
      }

      setAiTopicOptions(parsedTopics);
    } catch (err) {
      console.error("AI topic fetch failed:", err);
      setAiTopicOptions([]);
    }
  };

  fetchTopics();
}, [subject, selectedLessonId]);




useEffect(() => {
  // don't start timer on welcome page or after test finished
if (format === 'MentalMaths')
{
  setmaxQuestions(20);
}
else if (format === 'picture')
{
setmaxQuestions(10);
}
else
{
  setmaxQuestions(20);
}
}, [format]);

 useEffect(() => {
    const fetchAIResults = async () => {
      const user = auth.currentUser;

      if (!user) return;

      //alert(user.uid);

      try {
        const q = query(
          collection(db, "AI_Results"),
          where("uid", "==", user.uid),
          where("subject","==",subject),
          where("lesson","==",selectedLessonName),
          where("topic","==",topic),
          orderBy("timestamp", "desc"),
          limit(2)
        );

        const snapshot = await getDocs(q);

        if (snapshot.empty) {
          setResultsString("No results found.");
          return;
        }

        let finalText = "";

        snapshot.forEach(doc => {
          const data = doc.data();

          const wrongAnswers = (data.answers || []).filter(
            ans => ans.isCorrect === false
          );

          if (wrongAnswers.length === 0) return;

          finalText += `Lesson: ${data.lesson}\n`;
          finalText += `Subject: ${data.subject}\n`;
          finalText += `Wrong Questions:\n`;

          wrongAnswers.forEach((ans, index) => {
            finalText += `${index + 1}. ${ans.question}\n`;
          });

          finalText += `\n`;
        });

        setResultsString(finalText.trim());

      } catch (error) {
        console.error("Error fetching results:", error);
      }
    };

    fetchAIResults();

  }, [user,selectedLessonName,topic,subject]);

  useEffect(() => {
  if (!resultsString) return;

  const runAI = async () => {

    setIsAiSummaryLoading(true);

    setAiSummary(resultsString || "Unable to generate summary at the moment.");
    setIsAiSummaryLoading(false);

    };

    runAI();
  }, [resultsString]);


useEffect(() => {
  // don't start timer on welcome page or after test finished
if (welcomePage || isFinished) return;
if (!currentQuestion) return; // temporary skip until question is loaded


  // reset guard so timeout can fire again for the new question
  setAutoSubmitted(false);

  const duration = getDurationForSubject(subject);
  setTimeLeft(duration);

  // clear any lingering timeout
  if (countdownTimeoutRef.current) {
    clearTimeout(countdownTimeoutRef.current);
  }

  return () => {
    if (countdownTimeoutRef.current) {
      clearTimeout(countdownTimeoutRef.current);
    }
  };
}, [questionIndex, subject, currentQuestion, welcomePage, isFinished,allQuestions]);

useEffect(() => {
 if (welcomePage || isFinished) return;
if (!currentQuestion) return; // temporary skip until question is loaded

  // If time is up and we haven't auto-submitted yet, submit now
  if (timeLeft === 0) {
    if (!autoSubmitted) {
      setAutoSubmitted(true);
       // Use your existing qloading guard to avoid races with user clicks
      (async () => {
        if (qloading) return;
        setqLoading(true);
        try {
          // call handleSubmitAnswer in "auto" mode (we'll update it below)
          await handleSubmitAnswer(true);
        } catch (err) {
          console.error("Auto-submit error:", err);
        } finally {
          setqLoading(false);
        }
      })();
    }
    return;
  }

  // Normal countdown tick
  countdownTimeoutRef.current = setTimeout(() => {
    setTimeLeft(prev => prev - 1);
  }, 1000);

  return () => {
    if (countdownTimeoutRef.current) {
      clearTimeout(countdownTimeoutRef.current);
    }
  };
}, [timeLeft, autoSubmitted, welcomePage, isFinished, currentQuestion, qloading,allQuestions]);


  function jumbleWord(word, maxAttempts = 1000) {
  const original = word.trim();
  if (original.length < 2) return original;

  const unique = new Set(original.split(""));
  if (unique.size === 1) {
    return original; // cannot jumble identical chars
  }

  const arr = original.split("");
  for (let i = 0; i < maxAttempts; i++) {
    const shuffled = [...arr];
    for (let j = shuffled.length - 1; j > 0; j--) {
      const k = Math.floor(Math.random() * (j + 1));
      [shuffled[j], shuffled[k]] = [shuffled[k], shuffled[j]];
    }
    const candidate = shuffled.join("");
    if (candidate !== original) return candidate;
  }
  throw new Error("Failed to generate a different jumble");
}

function generateJumbledWords(text) {
  // extract only words of length 5-10
  const words = text
    .toLowerCase()
    .match(/\b[a-z]{5,10}\b/g);

    

  if (!words) return "No valid words found";

  const uniqueWords = [...new Set(words)]; // unique candidates

  // shuffle the array randomly
  const shuffled = uniqueWords.sort(() => Math.random() - 0.5);

  // pick up to 20 random words
  const selected = shuffled.slice(0, 20);

  //alert(selected);

  return selected
    .map(word => {
      const jumbled = jumbleWord(word);
      const question = jumbled.toUpperCase().split("").join(" ");
      return `Question: ${question}\nAnswer: ${word}`;
    })
    .join("\n\n");
}

useEffect(() => {
  const fetchSubjects = async () => {
    try {
      if (!standard || !school) return;

      const q = query(collection(db, 'lessons_ncert'), where('standard', '==', Number(standard)));
      const snapshot = await getDocs(q);
      
      // Map to "Subject: Book Name" format
      const subjectsWithBooks = snapshot.docs.map(doc => {
        const data = doc.data();
        // Use the 'book' field from your collection
        return data.book 
          ? `${data.subject}: ${data.book}` 
          : data.subject;
      });

      // Deduplicate and sort the list
      const uniqueSorted = [...new Set(subjectsWithBooks)].sort();
      setSubjectList(uniqueSorted);
    } catch (error) {
      console.error('Error fetching subjects:', error);
    }
  };

  fetchSubjects();
}, [standard]);


const handleClick = async () => {
  if (qloading) return; // ignore double click
  setqLoading(true);
try {
    await handleSubmitAnswer();   // your existing logic
  } finally {
    setqLoading(false);            // re-enable for next question
  }
};

const fetchPictureQuiz = async () => {
  try {
    //alert(`Images_Quiz/Images_Quiz_${subject}_${standard}`);
    const imagesRef = ref(storage, `Images_Quiz/Images_Quiz_${subject}_${standard}`);
    const result = await listAll(imagesRef);

    if (!result.items.length) {
      console.error("No images found in Images_Quiz");
      alert('No images found for selected subject and standard');
      navigate('/Old_Home')
      return;
    }

    // Shuffle result.items
    const shuffled = [...result.items];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }

    // Take 10 random images
    const selected = shuffled.slice(0, 10);

    // Get URLs for these images
    const urls = await Promise.all(
      selected.map(itemRef => getDownloadURL(itemRef))
    );

    // Create questions
    const questions = selected.map((itemRef, index) => ({
      id: index + 1,
      type: "fill-in-the-blank",
      question: `Identify the image `,
      imageUrl: urls[index],
      answer: itemRef.name.split('.')[0] ,// file name without extension,
      quiz_type:"image"
    }));

    setQuestionIndex(0);          // reset to first
    setAllQuestions(questions);
    setCurrentQuestion(questions[0]);
 
    
  } catch (error) {
    console.error("Error fetching picture quiz:", error);
  }
};
 

const get30DayWindow = () => {
  const now = new Date();
  return new Date(now.setDate(now.getDate() - 30));
};

async function fetchAIResponse(prompt) {

const callGemini = httpsCallable(functions, 'callGemini');
  // 2. Try Gemini as fallback
  try {
    const result = await callGemini({
      contents: [{ role: "user", parts: [{ text: prompt }] }],
      generationConfig: {
        maxOutputTokens: 8192,
        temperature: 0.7
      }
    });

    // 🛡️ Secure Note: The App Check token was sent automatically!
    // result.data contains the body of the response from your backend
    return result.data.candidates?.[0]?.content?.parts?.[0]?.text;

  } catch (err) {
    console.error('Gemini error:', err.message);
    
    // Check for specific security failures
    if (err.code === 'failed-precondition') {
      alert("Security Check Failed: Please refresh the page.");
    }
  }

  // If both fail
  alert("Oops All AI engines are busy for now .Please try in a couple of minutes.");
  return null;
}


useEffect(() => {
  const state = location.state;
  if (state) {
    //alert(state.combinedText);
    if (state.selectedLessonId) setSelectedLessonId(state.selectedLessonId);
    if (state.subject) setSubject(state.subject);
    if (state.format) setFormat(state.format);
    if (state.combinedText) 
      {
        combinedText = state.combinedText;
        setSelectedLessonId('Other');
        setSelectedLessonName('Image');
        setSelectedLessonText(combinedText);
        setFormat('MCQ');
        setTopic('Full Text of the Lesson');
        //alert(selectedLessonId);        
        //alert(combinedText);        
        //alert(format);        
        //alert(topic);
      // trigger the button programmatically
      // ensure button is rendered before clicking
      setTimeout(() => {
        document.getElementById("quizButton")?.click();
      }, 300);
      
      }
  }
}, []);//[location.state,selectedLessonId,selectedLessonText,format,topic,subject]);

useEffect(() => {
  if (selectedLessonId && savedLessons.length > 0) {
    const selected = savedLessons.find(l => l.id === selectedLessonId);
    if(selectedLessonId === "Other")
    {
      setSelectedLessonText(combinedText || '');
      setFormat('MCQ');
      setTopic('Full Text of the Lesson');
      setTimeout(() => {
        document.getElementById("quizButton")?.click();
      }, 300);
    }
    if (selected) {
      setSelectedLessonText(selected.extracted_text || '');
    }
  }
}, [savedLessons, selectedLessonId]);


  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (!currentUser) {
        alert("You must be logged in");
        navigate('/login');
      } else {
        setUser(currentUser);
        const docRef_Profiles = doc(db, 'profiles', currentUser.uid);
        const docSnap_Profiles = await getDoc(docRef_Profiles);
        if (docSnap_Profiles.exists()) {
          const profile = docSnap_Profiles.data();
          const type = profile.paidUser || false;
          setStandard(profile.standard || ""); 
          setSchool(profile.school);
          const endDate = profile.paidUser_End_Date          
                  ?.toDate?.()
                  ?.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
                  .replace(/ /g, '-') || 'Not Set';

          setUserProfile(profile);

          setUserType(type);
          setPremiumenddate(endDate);

                    // Fetch saved lessons

          const coreSubjects = ['English Language', 'Hindi Language'];
          
                const lessonsSnapshot = await getDocs(collection(db, 'lessons_ncert'));
          const filteredLessons = lessonsSnapshot.docs
            .map(doc => ({ id: doc.id, ...doc.data() }))
                .filter(item =>
                    //(item.email === user.email || item.sharedWith === 'parents') &&
                    //item.school === school &&
                    (
                    coreSubjects.includes(item.subject) || 
                    item.standard === Number(standard)
                    )
                );
                //alert(filteredLessons);
          setSavedLessons(filteredLessons);

          //alert(`UserType: ${type}`);
          //alert(`Premiumenddate: ${endDate}`);

          // 2️⃣ Now check generation count
          const todays_date = `${String(new Date().getDate()).padStart(2, '0')}-${["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"][new Date().getMonth()]}-${new Date().getFullYear()}`;

          //alert(`todays_date: ${todays_date}`);

          // Paid & active
          if (type === true && new Date(endDate) >= new Date(todays_date)) {
            setGenerationsLeft(999);
            //alert("Logged in as a premium user");
            return;
          }

          // Paid but expired
          if (type === true && new Date(endDate) < new Date(todays_date)) {
            alert("The Premium Eascode Service has ended.");
            await deleteDoc(doc(db, 'monthly_ai_quiz_generations', user.uid));
            await updateDoc(doc(db, 'profiles', user.uid), { paidUser: false });
            return;
          }
          else{

            //alert(`user id is`+profile.uid);

          // Free user limit check
          const docRef_check = doc(db, 'monthly_ai_quiz_generations', profile.uid);
          const docSnap_check = await getDoc(docRef_check);
          const thirtyDaysAgo = get30DayWindow();

          if (!docSnap_check.exists()) {
            await setDoc(docRef_check, { timestamps: [] });
            setGenerationsLeft(10);
          } else {
            const data = docSnap_check.data();
            const recentTimestamps = (data.timestamps || []).filter(ts => new Date(ts) >= thirtyDaysAgo);
            setGenerationsLeft(10 - recentTimestamps.length);
          }

        }


        }
      }
    });
    return () => unsubscribe();
  }, [navigate,db,user,subject]);

const parseAIResponse = (responseText) => {
  const lines = responseText.trim().split('\n');

  const questionLine = lines.find(line => line.toLowerCase().startsWith('question:'));
  const answerLine = lines.find(line => line.toLowerCase().startsWith('answer:'));
  const optionsLine = format === 'MCQ' || format === 'PatternMaths' ? lines.find(line => line.toLowerCase().startsWith('options:')) : null;

  const question = questionLine?.replace(/question:/i, '').trim();
  const answer = answerLine?.replace(/answer:/i, '').trim();
  //const options = optionsLine
    //? optionsLine.replace(/options:/i, '').split(',').map(opt => opt.trim())
    //: [];

      let options = [];

    if (format === 'MCQ' && optionsLine) {
      options = optionsLine
        .replace(/options:/i, '')
        .split('|')
        .map(opt => opt.trim());
    }

    else if (format === 'PatternMaths' && optionsLine) {
      options = optionsLine
        .replace(/options:/i, '')
        .split('|')
        .map(opt => opt.trim());
    }
    else {
      options = [];
    }

  return {
    question,
    type: format === 'MCQ' ? 'mcq' : 'text',
    options,
    answer,
    quiz_type:'text'
  };
};



const verifyWithAI = async (question, expectedAnswer, studentAnswer) => {

  let prompt = `You are a strict school teacher. A student answered the following question. Tell if the answer is correct or not, based on the expected answer. Only return 'true' or 'false'. Do not explain anything else.`;

  if (format === 'scramble')
  {
  prompt += `
Question: ${question}
Expected Answer: ${expectedAnswer}
Student Answer: ${studentAnswer}
`;
  }
  else{
  prompt = `
The student's answer can be different from the expected answer but if it is grammatically correct and as per the lesson text you should return true. 
Question: ${question}
Expected Answer: ${expectedAnswer}
Student Answer: ${studentAnswer}
`;
  }

  // First try OpenAI
 {/* try {
    const response = await fetch("https://us-central1-project-x-demo-6329b.cloudfunctions.net/callOpenAI", 
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'OpenAI-Organization': 'org-yyMRSevhIl7E71Kki1cV26xH'
        },
        body: JSON.stringify({
          model: "gpt-3.5-turbo",
          temperature: 0.9,
          messages: [{ role: 'user', content: prompt }],
        }),
      }
    );

    if (!response.ok) throw new Error('OpenAI failed');
    const data = await response.json();
    const content = data.choices[0]?.message?.content.trim().toLowerCase();
    return content.includes('true');
  } catch (openaiError) {
    console.warn('OpenAI failed, falling back to Gemini:', openaiError.message);
  }
*/}
  // Try Gemini as fallback
  try {

    const callGemini = httpsCallable(functions, 'callGemini');

const result = await callGemini({
  contents: [{ role: "user", parts: [{ text: prompt }] }],
  generationConfig: {
    temperature: 0
  }
});

const geminiContent = result.data?.candidates?.[0]?.content?.parts?.[0]?.text?.trim().toLowerCase();
return geminiContent?.includes('true') === true;

  } catch (geminiError) {
    console.warn('Gemini also failed:', geminiError.message);
    alert('Oops All AI engines are busy for now .Please try in a couple of minutes.');
    return false;
  }
};

const generateAllQuestions = async (extraAvoidQuestions = []) => {
  try {

    let questionList = "";

try {
  //alert("STEP 1: Starting Firestore query...");

  const q = query(
    collection(db, "AI_Results"),
    where("uid", "==", user.uid),
    where("subject", "==", subject),
    orderBy("timestamp", "desc"),
    limit(2)
  );



  const snapshot = await getDocs(q);

  if (snapshot.empty) {
    
  }else
  {
  const docData = snapshot.docs[0].data();
  questionList = docData.answers?.map(item => item.question) || [];
  }

} catch (error) {
  alert("❌ ERROR: " + error.message);
  console.error("❌ Error fetching questions:", error);
  return [];
}

  //alert(questionList);

// 🔥 NEW CODE: Merge Firestore history with manually rejected questions
  const rejectedQuestions = extraAvoidQuestions.map(q => q.question);
  const allAvoidQuestions = [...questionList, ...rejectedQuestions];

    let content = "";

    const lessonTextPrompt = selectedLessonText
      ? `Use different parts of the lesson to frame the questions not just one section of it. 
      Use this lesson text for framing your question: ${selectedLessonText} \n`
      : '';

      let prompt = `Do not hallucinate and stick to the details provided only .Do not show any text from my prompt.`           

      if (format === 'scramble')
      {

        prompt +=`pick 20 important words from the below lesson based on the context of the lesson, 
        minimum length of a word should be 5 alphabets and maximum 10 alphabets,
        do not repeat the words and separate each word using a space\n
        
        ${lessonTextPrompt}`;

        const selected_words = await fetchAIResponse(prompt);

        //alert(selected_words);

        //alert(prompt);

         content = generateJumbledWords(selected_words);

         //alert(content);
        }

        else if (format === 'MentalMaths')
      {

        

        if (sampleQuestions.length > 0)
        {

        //alert(sampleQuestions);

        prompt +=`You are a strict Maths teacher for students of standard ${userProfile?.standard} 
        you have to Make 25 Mental Maths questions for a student of standard ${userProfile?.standard} 
        understand the question ${sampleQuestions} and make similar questions only.\n

        Respond strictly in this format (for each question):
          Question: <question>
          Options: <Option1>| <Option2>| <Option3>| <Option4>   // only for MCQ
          Answer: <correct answer>
          Separate each question block with two new lines.

          Do not include any explanation or extra text.`;

        }

        else {

        prompt +=`You are a strict Maths teacher for students of standard ${userProfile?.standard} 
        you have to Make 25 Mental Maths questions for a student of standard ${userProfile?.standard} 
        based on sample questions given below. 

        1. product of 8 and 2 + 4 = ______\n
        2. Sum of 15 and 5 - 10 = _______\n
        3. 1 Fortnight + 3 days = ________ days\n
        4. Ajay eats 10 sweets in day . how many sweets will he eat in a week?\n
        5. How many months are there in 2 years?\n
        6. How many legs will 3 cats , 4 boys and 2 babies will have?\n
        7. January + 10 days = ______ days\n
        8. product of 4 and 2 minus sum of 2 and 2 = _____\n
        9. What number is to be added to 30 to make it 60 ?\n
        10. 100 + 3 tens = ____ tens?\n
        11. 1 score + 2 dozen = ____ \n
        12. 6 more than 4 tens = ___ \n
        13. 5 weeks - 7 days = _____ days\n
        14. Take away 3 from the product of 4 and 5 \n
        15. 3 dozen + 6 = _____\n
        16. How many sides will 3 squares,4 triangles and 2 rectangles will have?\n
        17. how many tens in 750?\n
        18. Smallest 4 digit number + 9 = ____\n
        19. Largest 3 digit number - 9 = _____\n
        20. Successor of 49 and predessor of 21 = ____ \n
        21. 4 X 4 + 3 = ____\n


        Respond strictly in this format (for each question) :
          Question: <question>
          Options: <Option1>| <Option2>| <Option3>| <Option4>   // only for MCQ
          Answer: <correct answer>
          Separate each question block with two new lines.

          Choose from all types of questions given above do not choose the subsequent question in the order given ,
          for every question above create 10 similar questions per question and then choose randomly 1 question from those 10 questions
          Do not include any explanation or extra text.Mix up the questions `;

        }

        //alert(questionList);

        prompt +=`make sure no questions are same as the below questions ${allAvoidQuestions.join(", ")}`

        content = await fetchAIResponse(prompt);

        //alert(prompt);

        //alert(content);
        }

      else if (format === 'PatternMaths')
      {

        

        if (sampleQuestions.length > 0)
        {

        //alert(sampleQuestions);

        prompt +=`You are a strict teacher for students of standard ${userProfile?.standard} 
        you have to Make 20 Multiple Choice Pattern Filling  questions for a student of standard ${userProfile?.standard} 
        randomize the question's ${sampleQuestions} and make similar questions only.Discard other types of questions\n
        students have to read the given pattern and deduce what pattern comes next in the sequence.
        Question must have , between the given values and the questions pattern must make some logical sense
        Options you give must have values for both missing patterns in questions separated by a comma
        7 question must have answer as option 1 , 4 question must have answer as option 2 ,
        6 question must have answer as option 3 and 3 question must have answer as option 4

        Respond strictly in this format (for each question):
          Question: <question>
          Options: <Option1>| <Option2>| <Option3>| <Option4>   // only for MCQ
          Answer: <correct answer>
          Separate each question block with two new lines.

          Do not include any explanation or extra text.`;

        }

        else {

        prompt +=`You are a strict teacher for students of standard ${userProfile?.standard} 
        you have to Make 20 Multiple Choice Pattern Filling questions for a student of standard ${userProfile?.standard} 
        Questions should always include 3 filled and 2 spaces for answers.
        Questions must be one or multiple icons like clock face ,arrows,squares,arrows and squares together,
        trees,triangles,squares with dots and other such similar icons and not numbers or alphabets / words.
        students have to read the given pattern and deduce what pattern comes next in the sequence.
        Patterns can be icons increasing by 1 ,icons decreasing by 1 ,changing clock time,rotation of an arrow head or similar such
        aptitude based questions. Mix and match the patterns for students to use their pattern matching skill appropriately.
        Question must have , between the given values and the questions pattern must make some logical sense
        Options you give must have values for both missing patterns in questions separated by a comma
        7 question must have answer as option 1 , 4 question must have answer as option 2 ,
        6 question must have answer as option 3 and 3 question must have answer as option 4


        Respond strictly in this format (for each question):
          Question: <question>
          Options: <Option1>| <Option2>| <Option3>| <Option4>   // only for MCQ
          Answer: <correct answer>
          Separate each question block with two new lines.`;

        }

        //alert(questionList);

        prompt +=`make sure no questions are same as the below questions ${questionList}`

        content = await fetchAIResponse(prompt);

        //alert(prompt);

        //alert(content);
        }

      else{
        if (preference === "No")
        {
    prompt += `Generate 20 different ${subject} questions for the topic '${topic}' in the format '${format}' 
          for standard ${userProfile?.standard}.

          make sure no question is neither same nor similar to the below questions ${questionList}

          Only base your question on the text given here ${lessonTextPrompt}. 

          if ${sampleQuestions} is provided please frame same type of questions only.\n
          
          Options should not have indexes like A),a) 1) i) etc., only the option values. 
          There should be only 4 options not more not less. 
          Spread the correct answer between the 4 options for MCQ types of questions
          Respond strictly in this format (for each question):
          Question: <question>
          Options: <Option1>| <Option2>| <Option3>| <Option4>   // only for MCQ
          Answer: <correct answer>
          Separate each question block with two new lines.

          Do not include any explanation or extra text.`;

          //alert(questionList);

          content = await fetchAIResponse(prompt);

        }

        if(preference === "Yes")
        {
        prompt += `Generate 20 different ${subject} questions for the topic '${topic}' in the format '${format}' 
          for standard ${userProfile?.standard}.

          only frame questions from below set of questions in exactly same wordings  ${aiSummary}

          Only base your question on the text given here ${lessonTextPrompt}. 

          if ${sampleQuestions} is provided please frame same type of questions only.\n
          
          Options should not have indexes like A),a) 1) i) etc., only the option values. 
          There should be only 4 options not more not less. 
          Spread the correct answer between the 4 options for MCQ types of questions
          Respond strictly in this format (for each question):
          Question: <question>
          Options: <Option1>| <Option2>| <Option3>| <Option4>   // only for MCQ
          Answer: <correct answer>
          Separate each question block with two new lines.

          Do not include any explanation or extra text.`;

          //alert(questionList);

          content = await fetchAIResponse(prompt);
        }

      }

    //alert(prompt);    

    //alert(content);
    
if (!content) return;

    const questionsArray = content
      .split('\n\n')
      .map(qBlock => parseAIResponse(qBlock))
      .filter(Boolean);

    // 🔥 NEW CODE: Extract lines for the review modal and pause the quiz
    const questionLines = content
      .split('\n')
      .filter(line => line.trim().startsWith('Question:'));

    setReviewContent(questionLines.join('\n\n'));
    setShowReviewModal(true);
    setPendingQuestions(questionsArray);

  } catch (error) {
    console.error("Error generating questions:", error);
  }
};


useEffect(() => {
  if (!welcomePage && allQuestions.length === 0 && standard) {
    if(format === 'picture')
    {
    fetchPictureQuiz();
    }
    else{
    generateAllQuestions();
    }
  } else if (allQuestions.length > 0 && questionIndex < maxQuestions) {
    //alert(questionIndex);
    setCurrentQuestion(allQuestions[questionIndex]);
  }
}, [welcomePage, allQuestions, questionIndex, standard]);

{/*
  const handleSubmitAnswer = async() => {

  let isCorrect = false;

  if (currentQuestion.type === 'mcq' || currentQuestion.type === 'image') {
    // Same logic for MCQ and exact answers
    //alert(selectedOption);
    //alert(currentQuestion.question);
    //alert(currentQuestion.answer);
    isCorrect = selectedOption.toLowerCase().trim() === currentQuestion.answer.toLowerCase().trim();
  } else {
    // For theoretical/open-ended questions - verify with ChatGPT
    const response = await verifyWithAI(currentQuestion.question, currentQuestion.answer, selectedOption);
    isCorrect = response === true;
  }

    const result = {
      question: currentQuestion.question,
      userAnswer: selectedOption,
      correctAnswer: currentQuestion.answer,
      isCorrect,
    };

    setUserAnswers(prev => [...prev, result]);

    if (isCorrect) setScore(prev => prev + 1);

    if (questionIndex + 1 >= maxQuestions) {
      setIsFinished(true);
      saveResults([...userAnswers, result]);
    } else {
      setSelectedOption('');
      setQuestionIndex(prev => prev + 1);
    }

  };
*/}

const handleSubmitAnswer = async (isAuto = false) => {
  try {
    // Prevent double submit
    if (qloading) return;
    setqLoading(true);

    let isCorrect = false;
    const userAns = (selectedOption || '').toString();

    //alert(currentQuestion.quiz_type);

    if (currentQuestion.type === 'mcq' || currentQuestion.quiz_type === 'image') {
      //alert(userAns.toLowerCase().trim());
      //alert((currentQuestion.answer || '').toLowerCase().trim());
      isCorrect = userAns.toLowerCase().trim() === (currentQuestion.answer || '').toLowerCase().trim();
    } else {
      // open-ended: only call AI verification if NOT auto-submitted and the student actually typed something
      if (!isAuto && userAns.trim() !== '') {
        const response = await verifyWithAI(currentQuestion.question, currentQuestion.answer, userAns);
        isCorrect = response === true;
      } else {
        // auto-submitted or empty answer -> mark incorrect (or change as you prefer)
        isCorrect = false;
      }
    }

    const result = {
      question: currentQuestion.question,
      userAnswer: userAns,
      correctAnswer: currentQuestion.answer,
      isCorrect,
    };

    // use a local array to compute finalAnswers (avoid stale state issues)
    const finalAnswers = [...userAnswers, result];
    setUserAnswers(finalAnswers);

    if (isCorrect) setScore(prev => prev + 1);

    if (questionIndex + 1 >= maxQuestions) {
      setIsFinished(true);
      await saveResults(finalAnswers); // pass computed finalAnswers

      setShowRewardBox(true);
      await fetchAllRewards();

      setRewardRevealed(true);


    } else {
      // move to next
      setSelectedOption('');
      setQuestionIndex(prev => prev + 1);
    }
  } catch (err) {
    console.error("submit error:", err);
  } finally {
    setqLoading(false);
  }
};

  

const saveResults = async (finalAnswers) => {
  const finalScore = finalAnswers.filter(ans => ans.isCorrect).length;

  await addDoc(collection(db, 'AI_Results'), {
    uid: user.uid,
    subject,
    topic,
    format,
    score: finalScore, // fixed!
    totalQuestions: finalAnswers.length,
    answers: finalAnswers,
    timestamp: new Date(),
    lesson:selectedLessonName,
    school:userProfile.school || 'Missing',
    standard:userProfile.standard || 'Missing',
    uploadername: userProfile.name
  });

 // alert(finalScore);
 // alert(finalAnswers.length);  

  const passPercentage = (finalScore / finalAnswers.length) * 100;

  //alert(passPercentage);  

  Set_Pass_Percentage(passPercentage);

  //alert(Pass_Percentage);

  if( passPercentage >= 50 && UserType === false)
  {
    //alert('Score more than 50%');
    await addDoc(collection(db, 'Reward_Capture'), {
    uid: user.uid,
    user_email:user.email,
    timestamp: new Date(),
    reward_category:'AI_Quiz'
  });
  }
  else{
    //alert('Score less than 50%');
  }
  

  };

const set_generations_left = async () => {
      const uid = user.uid;
      const doc_Generation = doc(db, 'monthly_ai_quiz_generations', uid);
      const docSnap = await getDoc(doc_Generation);
      const now = new Date().toISOString();
      const oldTimestamps = (docSnap.data()?.timestamps || []).filter(ts => {
      return new Date(ts) >= get30DayWindow();
      });

      const updatedTimestamps = [...oldTimestamps, now];
      await setDoc(doc_Generation, { timestamps: updatedTimestamps });

      const todays_date = `${String(new Date().getDate()).padStart(2, '0')}-${["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"][new Date().getMonth()]}-${new Date().getFullYear()}`;
 
      if (UserType === true && new Date(Premiumenddate) >= new Date(todays_date)) {
      setGenerationsLeft(999);
      //alert('x');
    //alert(`user type`+UserType);
    //alert(`Premiumenddate`+Premiumenddate);
    //alert(`todays_date`+todays_date);
      }
      else{
       setGenerationsLeft(10 - updatedTimestamps.length); 
             //alert('y');
    //alert(`user type`+UserType);
    //alert(`Premiumenddate`+Premiumenddate);
    //alert(`todays_date`+todays_date);
      }

    };




if (welcomePage) {
    return (
      <div className="min-h-screen bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-indigo-50 via-slate-50 to-white py-2 sm:py-6 px-2 sm:px-6 lg:px-8 font-sans">
        <div className="w-full max-w-5xl mx-auto bg-white/80 backdrop-blur-xl rounded-[1rem] sm:rounded-[2rem] shadow-2xl shadow-indigo-500/10 border border-white p-3 sm:p-8 relative overflow-hidden">
          
          {/* Top Nav & Header */}
          <div className="flex items-center justify-between mb-4 sm:mb-6 w-full gap-2">
            <div className="flex-1 flex justify-start min-w-0">
              <BackHomeButton backState={{ selectedLessonId, subject }} />
            </div>
            <div className="flex-auto text-center px-1 sm:px-4 shrink-0">
              <h2 className="text-sm sm:text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight leading-tight whitespace-nowrap">
                {format === "picture" ? "Picture " : format === "MentalMaths" ? "Mental Maths " : format === "PatternMaths" ? "Pattern " : "AI "} 
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-violet-600">Quiz</span>
              </h2>
            </div>

            <div className="flex-1 flex justify-end min-w-0">            
              <Get_Help/>
            </div>
            
            {/* 
            //Promo Badge 
            <div className="flex-1 flex justify-end min-w-0">
              <div className="relative group overflow-hidden bg-gradient-to-r from-indigo-600 via-violet-600 to-purple-700 p-[1px] rounded-full transition-transform hover:scale-[1.02] shrink-0">
                <div className="bg-slate-900/10 backdrop-blur-md px-2 py-1 sm:px-4 sm:py-2 rounded-full flex items-center gap-1 sm:gap-2 text-white shadow-inner">
                  <span className="text-[10px] sm:text-base animate-bounce">🎁</span>
                  <p className="text-[8px] sm:text-xs font-medium leading-tight whitespace-nowrap">
                    <span className="hidden lg:inline">Pass </span>
                    <span className="text-yellow-400 font-bold">10 <span className="hidden sm:inline">Quizzes</span><span className="sm:hidden">Qz</span></span> 
                    <span className="mx-0.5 sm:mx-1">=</span> 
                    <span className="text-yellow-400 font-bold"><span className="hidden sm:inline">Gift Card</span><span className="sm:hidden">Gift</span></span>
                  </p>
                </div>
              </div>
            </div>
            */}

          </div>
{/*
          <p className="text-center text-[10px] sm:text-sm text-slate-500 font-medium w-full mx-auto px-2 mb-6 sm:mb-8">
            This Tool will make 1 Quiz for the selected Lesson and Subject.
          </p>
*/}

          {/* Drop your reusable component here */}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start' }}>
            <Help_Video 
              videoId="oPIaPP-eZGOo?si=N6gp1W-typR_S120" /* ⚠️ Replace with actual YouTube ID */
              title="How to use Voice to Text" 
            />
          </div>

                <br></br>

          {/* Configuration Grid: Subject & Format */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-6 mb-4 sm:mb-6 max-w-4xl mx-auto">
            <div className="space-y-1 sm:space-y-2">
              <label className="block text-[11px] sm:text-sm font-bold text-slate-700 ml-1">Choose Subject</label>
              <select
                value={subject}
                disabled={loading}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  setSubject(selectedValue); // Keep full string "English: First Flight" in state for the UI
                  setAiTopicOptions([]);
                  setTopic("");
                }}
                className="w-full bg-slate-50 border-2 border-slate-200 rounded-md sm:rounded-xl px-2 py-1.5 sm:px-3 sm:py-3 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/10 transition-all outline-none text-[11px] sm:text-base font-semibold text-slate-700 cursor-pointer appearance-none"
              >
                <option value="">Select Subject</option>
                {[...new Set([...subjectList, "English Language", "Hindi Language"])].sort().map((subj, idx) => (
                  <option key={idx} value={subj}>{subj}</option>
                ))}
              </select>
            </div>

            <div className="space-y-1 sm:space-y-2">
              <label className="block text-[11px] sm:text-sm font-bold text-slate-700 ml-1">Choose Format</label>
              <select 
                value={format} 
                onChange={(e) => setFormat(e.target.value)} 
                className="w-full bg-slate-50 border-2 border-slate-200 rounded-md sm:rounded-xl px-2 py-1.5 sm:px-3 sm:py-3 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/10 transition-all outline-none text-[11px] sm:text-base font-semibold text-slate-700 cursor-pointer appearance-none"
              >
                <option value="">-- Choose Format --</option>
                <option value="MCQ">Multiple Choice Questions</option>
                {subject === "Maths" && (
                  <>
                    <option value="MentalMaths">Mental Maths Quiz</option>
                    <option value="PatternMaths">Pattern Maths Quiz</option>
                  </>
                )}
              </select>
            </div>
          </div>

          {/* Configuration Grid: Lesson & Topic */}
          {subject && format !== "picture" && format !== "MentalMaths" && format !== "PatternMaths" && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-6 mb-4 sm:mb-6 max-w-4xl mx-auto animate-in fade-in zoom-in-95 duration-200">
              <div className="space-y-1 sm:space-y-2">
                <label className="block text-[11px] sm:text-sm font-bold text-slate-700 ml-1">Choose 1 Lesson</label>
                <select
                  value={selectedLessonId}
                  onChange={(e) => {
                    const selected = savedLessons.find(l => l.id === e.target.value);
                    if (e.target.value === 'Use without a Lesson' || e.target.value === "") {
                      setSelectedLessonId(e.target.value);
                      setSelectedLessonText(""); 
                    } else if (e.target.value === '0') {
                      setSelectedLessonText(combinedText); 
                    } else {
                      setSelectedLessonId(e.target.value);
                      setSelectedLessonText(selected?.extracted_text || "");
                      setSelectedLessonName(selected?.lesson_name || 'No Lesson');
                    }
                  }}
                  className="w-full bg-slate-50 border-2 border-slate-200 rounded-md sm:rounded-xl px-2 py-1.5 sm:px-3 sm:py-3 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/10 transition-all outline-none text-[11px] sm:text-base font-semibold text-slate-700 cursor-pointer appearance-none"
                >
                <option value="">-- Select a Lesson --</option>
                {savedLessons
                  .filter((lesson) => {
                    // If the subject state contains a colon, split it
                    if (subject.includes(':')) {
                      const [subjName, bookName] = subject.split(':').map(s => s.trim());
                      return lesson.subject === subjName && lesson.book === bookName;
                    }
                    // Fallback for core subjects like "Maths" or "Hindi Language"
                    return lesson.subject === subject;
                  })
                  .sort((a, b) => (a.lesson_name || '').localeCompare(b.lesson_name || ''))
                  .map((lesson) => (
                    <option key={lesson.id} value={lesson.id}>
                      Lesson Name - {lesson.lesson_name || 'No Title'}
                    </option>
                  ))}
                  {savedLessons.filter((lesson) => lesson.subject === subject).length === 0 && (
                    <option value="Use without a Lesson">Use without a Lesson</option>
                  )}
                </select>
              </div>

              <div className="space-y-1 sm:space-y-2">
                <label className="block text-[11px] sm:text-sm font-bold text-slate-700 ml-1">Choose Topic</label>
                <select
                  value={topic}
                  onChange={(e) => setTopic(e.target.value)}
                  className="w-full bg-slate-50 border-2 border-slate-200 rounded-md sm:rounded-xl px-2 py-1.5 sm:px-3 sm:py-3 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/10 transition-all outline-none text-[11px] sm:text-base font-semibold text-slate-700 cursor-pointer appearance-none"
                >
                  <option value="">Please Select topic</option>
                  {(subject === 'English Literature' || subject === 'Hindi Literature') && <option value="Who said to whom">Who said to whom</option>}
                  {subject === 'Maths' && (
                    <>
                      <option value="Addition">Addition</option>
                      <option value="Ascending and Descending Order">Ascending and Descending Order</option>
                      <option value="Comparison">Comparison</option>
                      <option value="Division">Division</option>
                      <option value="Mixed Maths Questions">Mixed Maths Questions</option>
                      <option value="Missing Numbers">Missing Numbers</option>
                      <option value="Multiplication">Multiplication</option>
                      <option value="Number Names">Number Names</option>
                      <option value="Repeated Addition">Repeated Addition</option>
                      <option value="Repeated Multiplication">Repeated Multiplication</option>
                      <option value="Repeated Subtraction">Repeated Subtraction</option>
                      <option value="StorySums">StorySums</option>
                      <option value="Subtraction">Subtraction</option>
                    </>
                  )}
                  {subject === 'English Language' && (
                    <>
                      <option value="Adjectives">Adjectives</option>
                      <option value="Antonyms">Antonyms</option>
                      <option value="Articles">Articles a an the</option>
                      <option value="Conjunctions">Conjunctions and but</option>
                      <option value="Identify Nouns">Identify Nouns</option>
                      <option value="Identify Verbs">Identify Verbs</option>
                      <option value="Jumbled Sentences">Jumbled Sentences</option>
                      <option value="Mixed English Language Questions">Mixed English Language Questions</option>
                      <option value="Pronouns">Pronouns</option>
                      <option value="Singular and Plural">Singular_Plural</option>
                      <option value="Subject and Predicate">Subject and Predicate</option>
                      <option value="Synonyms">Synonyms</option>
                      <option value="Tenses">Tenses</option>
                      <option value="Vocabulary">Vocabulary</option>
                    </>
                  )}
                  {subject === 'Hindi Language' && (
                    <>
                      <option value="Anunasik">Anunasik</option>
                      <option value="Anuswar">Anuswar</option>
                      <option value="Counting 1 to 15">Counting 1 to 15</option>
                      <option value="Mixed Hindi Language Questions">Mixed Hindi Language Questions</option>
                      <option value="Paryayvachi">Paryayvachi</option>
                      <option value="Saal ke Maheenon ke Naam">Saal ke Maheenon ke Naam</option>
                      <option value="Sangya">Sangya</option>
                      <option value="Sarvnaam">Sarvnaam</option>
                      <option value="Saptah ke Dinon ke naam">Saptah ke Dinon ke naam</option>
                      <option value="VakyaRachna">VakyaRachna</option>
                      <option value="VilomShabd">VilomShabd</option>
                      <option value="Viram Sign">Viram Sign</option>
                    </>
                  )}
                  {!(subject === 'Maths' || subject === 'English Language' || subject === 'Hindi Language') && (
                    <>
                      <option value="Full Text of the Lesson" className="bg-emerald-100 font-bold text-emerald-900">Full Text of the Lesson</option>
                      {aiTopicOptions.map((t) => <option key={t} value={t}>{t}</option>)}
                    </>
                  )}
                </select>
              </div>
            </div>
          )}

          {/* Smart AI Section: Weaker Sections & Sample Questions */}
          <div className="max-w-4xl mx-auto space-y-4 sm:space-y-6 mb-6 sm:mb-8">
            
            {subject && format !== "picture" && format !== "MentalMaths" && format !== "PatternMaths" && (
              <div className="bg-slate-900 text-white rounded-lg sm:rounded-2xl p-3 sm:p-5 shadow-lg relative overflow-hidden">
                <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-3 relative z-10">
                  <div className="flex items-center gap-2 shrink-0">
                    <span className="text-lg sm:text-2xl">🧠</span>
                    <div>
                      <h4 className="text-[11px] sm:text-base font-bold leading-none">Focus on Weaker Sections</h4>
                      <p className="text-[9px] sm:text-xs text-indigo-200 mt-0.5">Based on last 2 quizzes.</p>
                    </div>
                  </div>
                  
                  <select
                    value={preference}
                    onChange={(e) => setPreference(e.target.value)}
                    className={`px-2 py-1.5 sm:px-3 sm:py-2 rounded-md sm:rounded-lg text-[10px] sm:text-xs font-bold border-none outline-none text-slate-900 shadow-sm cursor-pointer shrink-0
                      ${preference === "No" ? "bg-slate-200" : "bg-emerald-400"}`}
                  >
                    <option value="No">Disabled</option>
                    <option value="Yes">Enable AI Focus</option>
                  </select>
                </div>

                {preference === "Yes" && (
                  <div className="mt-3 sm:mt-4 bg-slate-800/50 rounded-md sm:rounded-xl p-2 sm:p-4 border border-slate-700 backdrop-blur-sm relative z-10 animate-in slide-in-from-top-2 duration-200">
                    <h5 className="text-[9px] sm:text-xs font-bold text-indigo-300 uppercase tracking-widest mb-1">Identified Weak Sections</h5>
                    {isAiSummaryLoading ? (
                      <div className="flex flex-col items-center justify-center py-2 text-indigo-300">
                        <div className="w-4 h-4 sm:w-6 sm:h-6 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin mb-1"></div>
                        <p className="font-medium animate-pulse text-[9px] sm:text-xs text-center">Analyzing...</p>
                      </div>
                    ) : (
                      <pre className="whitespace-pre-wrap font-mono text-[9px] sm:text-xs leading-tight text-slate-200 overflow-x-auto max-h-16 sm:max-h-32 custom-scrollbar">
                        {aiSummary}
                      </pre>
                    )}
                  </div>
                )}
              </div>
            )}

            {format !== "picture" && (
              <div className="space-y-1 sm:space-y-2">
                <label className="block text-[11px] sm:text-sm font-bold text-slate-700 ml-1">Recommended Sample Questions (Optional)</label>
                <textarea
                  {...(format === "PatternMaths" ? { defaultValue: `🌳 , 🌳🌳 , 🌳🌳🌳 , ___ , ___\n◼️ , ◼️◼️ , ◼️ , ___ , ___\n➡️ , ⬆️ , ⬅️ , ___ , ___\n🕒 , 🕓 , 🕔 , ___ , ___\n🔺 , 🔺🔺 , 🔺🔺🔺 , ___ , ___` } : {})}
                  {...(format === "MentalMaths" ? { defaultValue: `1. product of 8 and 2 + 4 = ______\n2. Sum of 15 and 5 - 10 = _______\n3. 1 Fortnight + 3 days = ________ days` } : {})}
                  onChange={(e) => setSampleQuestions(e.target.value)}
                  placeholder="Enter sample questions here to guide AI..."
                  className="w-full bg-slate-50 border-2 border-slate-200 rounded-md sm:rounded-xl p-2 sm:p-4 text-[11px] sm:text-sm focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 outline-none resize-y h-20 sm:h-32 custom-scrollbar"
                />
              </div>
            )}
          </div>

          {/* Account Limits & Action Buttons */}
          <div className="max-w-4xl mx-auto space-y-4 sm:space-y-6">
            <div className="flex flex-row justify-center gap-2 sm:gap-4 w-full">
              <div className="bg-slate-100 px-3 py-1.5 sm:px-4 sm:py-2.5 rounded-md sm:rounded-xl text-center flex-1 max-w-[200px]">
                <span className="text-[8px] sm:text-[10px] font-bold text-slate-500 uppercase block mb-0.5">Quota</span>
                <span className="text-[11px] sm:text-sm font-black text-indigo-600">{generationsLeft} Left</span>
              </div>
              <div className="bg-slate-100 px-3 py-1.5 sm:px-4 sm:py-2.5 rounded-md sm:rounded-xl text-center flex-1 max-w-[200px]">
                <span className="text-[8px] sm:text-[10px] font-bold text-slate-500 uppercase block mb-0.5">Premium Until</span>
                <span className="text-[11px] sm:text-sm font-black text-slate-800 truncate">{Premiumenddate.toLocaleString().split(',')[0]}</span>
              </div>
            </div>

            {generationsLeft > 0 ? (
              <button
                id="quizButton"
                disabled={loading}
                onClick={() => {
                  if (format !== 'picture' && format !== 'MentalMaths' && format !== 'PatternMaths') {
                    if (!subject || !topic || !format || !selectedLessonId ) {
                      alert("Please select Subject, Lesson, Topic, and Format");
                      return;
                    }
                  }
                  if (format === 'picture' || format === 'MentalMaths' || format === 'PatternMaths') {
                    if (!subject || format === '--Choose Format--' || !format) {
                      alert("Please select Subject and Format");
                      return;
                    }
                  }
                  setWelcomePage(false);
                  set_generations_left();
                }}
                className="w-full bg-slate-900 text-white p-3 sm:p-4 rounded-lg sm:rounded-2xl font-bold text-[12px] sm:text-base hover:bg-indigo-600 transition-all duration-300 shadow-lg hover:shadow-indigo-500/30 flex justify-center items-center gap-2 disabled:opacity-50"
              >
                {loading ? (
                  <><div className="w-4 h-4 sm:w-5 sm:h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div> Generating...</>
                ) : format === "picture" ? '🖼️ Generate Picture Quiz'
                  : format === "MentalMaths" ? '🧠🔢 Generate Mental Maths Quiz'
                  : format === "PatternMaths" ? '🧠 → , ↑ , ← , ? , ? Generate Pattern Maths Quiz'
                  : '✨ Generate AI Quiz'}
              </button>
            ) : (
              <div className="w-full flex justify-center p-2 sm:p-4 bg-rose-50 border border-rose-200 rounded-lg sm:rounded-2xl">
                <RazorpayButton />
              </div>
            )}

            {generationsLeft <= 0 && (
              <p className="text-rose-600 font-bold text-center text-[10px] sm:text-sm mt-2">
                You have reached the Monthly limit. Please Subscribe to Eascode Premium to unlock unlimited usage.
              </p>
            )}
            
            <p className="text-center text-[9px] sm:text-xs text-slate-400 mt-4">AI can make mistakes. Please retry in such a case.</p>
          </div>

        </div>
      </div>
    );
  }
  

if (isFinished) {
    return (
      <div className="min-h-screen bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-indigo-50 via-slate-50 to-white py-4 sm:py-8 px-3 sm:px-6 lg:px-8 font-sans relative">
        
        {/* Reward Box Overlay */}
        {showRewardBox && (
          <div 
            onClick={() => { setShowRewardBox(false); setRewardRevealed(false); }}
            className="fixed inset-0 bg-slate-900/70 backdrop-blur-sm z-[9999] flex items-center justify-center p-4 cursor-pointer animate-in fade-in duration-300"
          >
            {!rewardRevealed && Pass_Percentage >= 50 && (
              <div onClick={(e) => e.stopPropagation()} className="bg-white p-6 sm:p-8 rounded-2xl sm:rounded-3xl shadow-2xl max-w-sm w-full text-center animate-in zoom-in-95 duration-300">
                <img src="/Winner_Trophy.gif" alt="Winner" className="w-40 sm:w-56 mx-auto mb-4 sm:mb-6" />
                <button 
                  onClick={() => handleNavigation('/RewardJourney')}
                  className="w-full bg-gradient-to-r from-amber-400 to-orange-500 text-white font-bold py-3 sm:py-4 px-4 sm:px-6 rounded-xl sm:rounded-2xl shadow-lg hover:scale-[1.02] transition-transform text-sm sm:text-base"
                >
                  🏆 Open Reward Center
                </button>
              </div>
            )}

            {!rewardRevealed && Pass_Percentage < 50 && (
              <div onClick={(e) => e.stopPropagation()} className="bg-white p-6 sm:p-8 rounded-2xl sm:rounded-3xl shadow-2xl max-w-sm w-full text-center animate-in zoom-in-95 duration-300">
                <img src="/Keep_Trying.jpg" alt="Keep Trying" className="w-40 sm:w-56 mx-auto mb-4 sm:mb-6 rounded-xl" />
                <button 
                  onClick={() => handleNavigation('/RewardJourney')}
                  className="w-full bg-slate-200 text-slate-700 font-bold py-3 sm:py-4 px-4 sm:px-6 rounded-xl sm:rounded-2xl hover:bg-slate-300 transition-colors text-sm sm:text-base"
                >
                  Score 50%+ to Win Rewards
                </button>
              </div>
            )}
          </div>
        )}

        <div className="w-full max-w-4xl mx-auto bg-white/80 backdrop-blur-xl rounded-[1rem] sm:rounded-[2rem] shadow-2xl shadow-indigo-500/10 border border-white p-4 sm:p-8">
          <div className="text-center mb-6 sm:mb-10">
            <h2 className="text-2xl sm:text-4xl font-extrabold text-slate-900 mb-2">Test Completed 🎉</h2>
            <div className="inline-block bg-indigo-100 text-indigo-800 px-4 sm:px-6 py-2 sm:py-3 rounded-full font-black text-lg sm:text-2xl shadow-sm">
              Your Score: {score} / {maxQuestions}
            </div>
          </div>

          <h3 className="text-sm sm:text-lg font-bold text-slate-700 mb-4 border-b border-slate-200 pb-2">Answer Breakdown:</h3>
          
          <div className="space-y-3 sm:space-y-4 mb-8">
            {userAnswers.map((ans, index) => (
              <div key={index} className={`p-4 sm:p-5 rounded-xl sm:rounded-2xl border-2 transition-all ${ans.isCorrect ? 'bg-emerald-50 border-emerald-200' : 'bg-rose-50 border-rose-200'}`}>
                <p className="font-bold text-slate-800 text-[11px] sm:text-sm mb-2"><span className="text-indigo-500 mr-1">Q{index + 1}.</span> {ans.question}</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-[10px] sm:text-sm">
                  <p className="text-slate-600"><span className="font-semibold text-slate-500">Your Answer:</span> {ans.userAnswer || <span className="italic text-slate-400">Blank</span>}</p>
                  <p className="text-slate-600"><span className="font-semibold text-slate-500">Correct Answer:</span> {ans.correctAnswer}</p>
                </div>
                <div className={`mt-3 inline-flex items-center px-2.5 py-1 rounded-md text-[9px] sm:text-xs font-bold uppercase tracking-wider ${ans.isCorrect ? 'bg-emerald-200 text-emerald-800' : 'bg-rose-200 text-rose-800'}`}>
                  {ans.isCorrect ? '✅ Correct' : '❌ Incorrect'}
                </div>
              </div>
            ))}
          </div>

          <div className="flex justify-center">
            <BackHomeButton />
          </div>
        </div>
      </div>
    );
  }


if (!currentQuestion && !showReviewModal) {
    return (
      <div className="min-h-screen bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-indigo-50 via-slate-50 to-white flex items-center justify-center font-sans">
        <div className="flex flex-col items-center gap-4 text-indigo-600">
          <div className="w-10 h-10 sm:w-12 sm:h-12 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin"></div>
          <p className="font-bold text-sm sm:text-base animate-pulse">Generating your custom AI Quiz...</p>
        </div>
      </div>
    );
  }

return (
    <div className="min-h-screen bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-indigo-50 via-slate-50 to-white py-4 sm:py-10 px-3 sm:px-6 lg:px-8 font-sans flex items-center justify-center">
      
      {/* Review Modal Overlay */}
      {showReviewModal && (
        <div className="fixed inset-0 bg-slate-900/70 backdrop-blur-sm z-50 flex justify-center items-center p-4">
          <div className="bg-white p-5 sm:p-8 w-full max-w-2xl rounded-2xl sm:rounded-3xl shadow-2xl animate-in zoom-in-95 duration-300 flex flex-col max-h-[90vh]">
            <h2 className="text-lg sm:text-2xl font-bold text-slate-800 mb-4">Review Generated Questions</h2>
            
            <div className="flex-1 overflow-y-auto bg-slate-50 border border-slate-200 rounded-xl p-3 sm:p-4 text-[10px] sm:text-sm font-mono text-slate-700 whitespace-pre-wrap custom-scrollbar mb-6">
              {reviewContent}
            </div>

            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 shrink-0">
              <button
                onClick={() => {
                  setShowReviewModal(false);
                  setRejectedHistory(prev => [...prev, ...pendingQuestions]);
                  generateAllQuestions([...rejectedHistory, ...pendingQuestions]);
                }}
                className="flex-1 bg-amber-500 text-white font-bold py-3 sm:py-4 px-4 rounded-xl sm:rounded-2xl hover:bg-amber-600 active:scale-95 transition-all shadow-md flex items-center justify-center gap-2 text-xs sm:text-base"
              >
                🔄 Regenerate
              </button>
              <button
                onClick={() => {
                  setShowReviewModal(false);
                  if (pendingQuestions.length) {
                    setQuestionIndex(0);
                    setAllQuestions(pendingQuestions);
                    setCurrentQuestion(pendingQuestions[0]);
                  }
                }}
                disabled={!pendingQuestions.length}
                className="flex-1 bg-emerald-600 text-white font-bold py-3 sm:py-4 px-4 rounded-xl sm:rounded-2xl hover:bg-emerald-700 active:scale-95 transition-all shadow-md disabled:opacity-50 flex items-center justify-center gap-2 text-xs sm:text-base"
              >
                ✅ Proceed to Quiz
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Active Quiz View */}
      {!showReviewModal && currentQuestion && (
        <div className="w-full max-w-2xl bg-white/90 backdrop-blur-xl rounded-[1.5rem] sm:rounded-[2rem] shadow-2xl shadow-indigo-500/10 border border-white p-5 sm:p-10">
          
          {/* Progress Header */}
          <div className="mb-6 sm:mb-8">
            <div className="flex justify-between items-end mb-2">
              <span className="text-[10px] sm:text-sm font-bold text-slate-500 uppercase tracking-widest">Question {questionIndex + 1} of {maxQuestions}</span>
              <div className="bg-rose-100 text-rose-700 px-3 sm:px-4 py-1 rounded-full text-[10px] sm:text-xs font-black flex items-center gap-1.5 animate-pulse">
                <span>⏳</span> {timeLeft}s
              </div>
            </div>
            <div className="h-2 sm:h-3 w-full bg-slate-100 rounded-full overflow-hidden">
              <div 
                className="h-full bg-emerald-500 rounded-full transition-all duration-500 ease-out" 
                style={{ width: `${((questionIndex + 1) / maxQuestions) * 100}%` }} 
              />
            </div>
          </div>

          {/* Question Content */}
          <div className="mb-6 sm:mb-8 text-center sm:text-left">
            {format === 'picture' && currentQuestion.imageUrl ? (
              <div className="mb-6 rounded-xl sm:rounded-2xl overflow-hidden border-2 border-slate-100 shadow-sm bg-slate-50">
                <img 
                  src={currentQuestion.imageUrl} 
                  alt={`Question ${questionIndex + 1}`} 
                  className="w-full max-h-[200px] sm:max-h-[300px] object-contain mx-auto" 
                />
              </div>
            ) : null}
            <h2 className="text-base sm:text-2xl font-bold text-slate-800 leading-snug">
              {currentQuestion.question}
            </h2>
          </div>

          {/* Input / Options */}
          <div className="mb-6 sm:mb-8">
            {currentQuestion.options && currentQuestion.options.length > 0 ? (
              <div className="flex flex-col gap-2 sm:gap-3">
                {currentQuestion.options.map((opt, i) => (
                  <button
                    key={i}
                    onClick={() => setSelectedOption(opt)}
                    className={`w-full text-left px-4 py-3 sm:px-5 sm:py-4 rounded-xl sm:rounded-2xl border-2 font-semibold text-xs sm:text-base transition-all duration-200
                      ${selectedOption === opt 
                        ? 'border-emerald-500 bg-emerald-50 text-emerald-800 shadow-md scale-[1.01]' 
                        : 'border-slate-200 bg-white text-slate-600 hover:border-indigo-300 hover:bg-indigo-50'}`}
                  >
                    {opt}
                  </button>
                ))}
              </div>
            ) : (
              <input
                type="text"
                placeholder="Type your answer here..."
                value={selectedOption}
                onChange={(e) => setSelectedOption(e.target.value)}
                className="w-full bg-slate-50 border-2 border-slate-200 rounded-xl sm:rounded-2xl px-4 py-3 sm:px-5 sm:py-4 text-sm sm:text-lg focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 transition-all outline-none font-medium text-slate-800 placeholder:text-slate-400 text-center sm:text-left"
              />
            )}
          </div>

          {/* Submit/Next Button */}
          <button
            onClick={handleClick}
            disabled={loading || !selectedOption}
            className="w-full bg-slate-900 text-white py-3.5 sm:py-4 rounded-xl sm:rounded-2xl font-bold text-sm sm:text-lg hover:bg-indigo-600 transition-all duration-300 shadow-lg hover:shadow-indigo-500/30 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 group"
          >
            {loading ? (
              <><div className="w-4 h-4 sm:w-5 sm:h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div> Processing...</>
            ) : (
              questionIndex + 1 === maxQuestions ? '🏁 Finish Test' : 'Next Question ➡️'
            )}
          </button>

          {/* Nav Back */}
          <div className="mt-6 flex justify-center">
            <BackHomeButton />
          </div>

        </div>
      )}

    </div>
  )



};

export default AIQuestionTest_CBSE_NCERT;